"use client";

import { InputProps } from "@/types";

export default function Input({
	label,
	helperText,
	className = "",
	id,
	...props
}: InputProps) {
	const inputId = id ?? props.name;

	return (
		<label className="flex w-full flex-col gap-2 text-sm text-[var(--text)]">
			{label ? <span className="font-medium">{label}</span> : null}
			<input
				id={inputId}
				className={`w-full rounded-2xl border border-[var(--stroke)] bg-[var(--panel)] px-4 py-3 text-sm text-[var(--text)] shadow-sm outline-none transition focus:border-[var(--accent)] focus:ring-2 focus:ring-[var(--accent)]/20 ${className}`}
				{...props}
			/>
			{helperText ? (
				<span className="text-xs text-[var(--muted)]">
					{helperText}
				</span>
			) : null}
		</label>
	);
}
